import Badge from "./Badge"

export type InlineSavingStatus = "idle" | "saving" | "error"

interface InlineSavingChipProps {
  status: InlineSavingStatus
  onRetry?: () => void
}

/**
 * Inline status chip for optimistic field/status edits in a detail view
 * (design.md — receta "Toggle de detalle"). Renders nothing once the
 * mutation settles successfully; only "saving" and "error" are visible.
 */
export default function InlineSavingChip({ status, onRetry }: InlineSavingChipProps) {
  if (status === "idle") return null

  if (status === "saving") {
    return (
      <span role="status" aria-live="polite" className="inline-flex">
        <Badge
          size="sm"
          color="light"
          startIcon={<span className="h-2 w-2 animate-pulse rounded-full bg-current" aria-hidden="true" />}
        >
          Guardando…
        </Badge>
      </span>
    )
  }

  return (
    <span role="status" aria-live="assertive" className="inline-flex">
      <button type="button" onClick={onRetry} className="inline-flex min-h-11 items-center">
        <Badge size="sm" color="error">
          No se guardó · reintentar
        </Badge>
      </button>
    </span>
  )
}
